// extracted by mini-css-extract-plugin
module.exports = {"whole":"Pageviews_whole__3UdSQ","search":"Pageviews_search__3BQhh","components":"Pageviews_components__1WWii"};